import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { PlaceType } from '../constants/PlaceType';
import Places from '../services/places';

export const useGetRecentPlacesList = () => {

  const [ recentPlaces, setRecentPlaces ] = useState([]);

  const { data } = useQuery(['recentPlace'], Places.recentPlaces, {
    refetchOnWindowFocus: false,
  });

  const getAirportDescription = (item) => {
    return `${item?.airport?.name}, ${item?.address?.state} ${item.address?.zip}, ${item.address?.country}`
  };

  useEffect(
    () => {
        if (data?.length) {
          const newPlaces = data.reduce((places, item) => {
            places.push({
              description: item.placeType === PlaceType.AIRPORT ? getAirportDescription(item) : item?.address?.full,
              type: item.type,
              placeType: item.placeType,
              address: item.address,
            })
            return places;
          }, []);
          setRecentPlaces(newPlaces);
        }
    }, [ data ]
  );

  return recentPlaces;
};


